function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, fieldset, [tabindex]:not([tabindex^='-']), [draggable], area, select, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
    )
  );
}
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  console.log("elements", elements);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
//Accessibility helpers
document.addEventListener("DOMContentLoaded", function () {
  //unpack all node elements at once using rest and secure target href links
  [...document.querySelectorAll("a[target=_blank]")].forEach(function (item) {
    item.setAttribute("rel", "noopener noreferrer");
  });
  document.querySelectorAll(".ss-list").forEach(function (select) {
    select.setAttribute("aria-label", "choose-option");
  });
  //Selectors
  const sidebar = document.querySelectorAll(".js-menu-toggle"),
    panel = document.querySelector(".js-mini-cart-contents"),
    addToCartBtns = document.querySelectorAll(".add-to-cart-button"),
    mainMenu = document.querySelector(".js-menu-toggle-home");
  var cartSummary = document.querySelector(".mini-cart-recommendations");
  if (cartSummary != null) {
    var cartBtn = cartSummary.querySelector(".mini-container");
    var n = cartBtn.querySelector(".view-cart-btn").length;
    var span = cartSummary.querySelector(".tax-note");
    var recCartLastButton = document.querySelector(
      ".cart-recommendations-drawer .product-card-item:last-child .button"
    );
    if (recCartLastButton != null) {
      recCartLastButton.addEventListener("focusout", function (e) {
        document.querySelector("body").classList.remove("show-sidebar");
        mainMenu.focus();
      });
    } else {
      span.addEventListener("focusout", function (e) {
        console.log("card drawer focusout");
        document.querySelector("body").classList.remove("show-sidebar");
        mainMenu.focus();
      });
    }
  }
  //if cart icon is focused
  if (sidebar != null) {
    sidebar.forEach(function (item, index) {
      item.addEventListener("click", function (e) {
        document.querySelector("aside.sidebar").setAttribute("tabindex", 0);
        document.querySelector("aside.sidebar").focus();
      });
    });
  }
  //move focus to cart drawer
  if (addToCartBtns.length > 0) {
    addToCartBtns.forEach(function (addToCartBtn) {
      addToCartBtn.addEventListener("click", function (e) {
        document.querySelector("aside.sidebar").focus;
      });
    });
  }
});
document.addEventListener("keydown", function (event) {
  var activeElement = document.activeElement;
  if (event.shiftKey && event.key === "Tab") {
    if (document.querySelectorAll("#cart").length > 0) {
      document
        .querySelectorAll(
          "#page-cart-inner #cart-fieldset .cart-items>.line-item"
        )
        .forEach(function (selfClass) {
          var doc1 = selfClass.querySelector(".remove-lines");
          var doc2 = document.activeElement;
          if (doc1 == doc2) {
            event.preventDefault();
            selfClass.querySelector(".line-image a").focus();
          }
        });
    } else {
      document
        .querySelectorAll("#cart-fieldset .cart-items>.line-item")
        .forEach(function (selfClass) {
          var doc1 = selfClass.querySelector(".remove-lines");
          var doc2 = document.activeElement;
          if (doc1 == doc2) {
            event.preventDefault();
            selfClass.querySelector(".line-image a").focus();
          }
        });
    }
  }
  if (event.key === "Tab" && !event.shiftKey) {
    if (document.querySelectorAll("#product").length > 0) {
      var doc1 = document.activeElement;
      var doc2 = document.querySelector(
        ".featured-products>.collection-toggle:last-child .add-to-cart-button"
      );
      if (doc1 == doc2) {
        event.preventDefault();
        document.querySelector(".main-featured-products .glider-prev").focus();
      }
      var doc3 = document.querySelector(".main-featured-products .glider-prev");
      if (doc1 == doc3) {
        event.preventDefault();
        document.querySelector(".main-featured-products .glider-next").focus();
      }
      var doc4 = document.querySelector(
        ".section-product-tabs .nav-tabs .nav-item:last-child .nav-link"
      );
      if (doc1 == doc4) {
        if (
          document.querySelector(
            ".product-recomendations-section .controls-rec .glider-prev"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(
              ".product-recomendations-section .controls-rec .glider-prev"
            )
            .focus();
        }
      }
      var doc5 = document.querySelector(
        ".product-recomendations-section .controls-rec .glider-prev"
      );
      if (doc1 == doc5) {
        if (
          document.querySelector(
            ".product-recomendations-section .controls-rec .glider-next"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(
              ".product-recomendations-section .controls-rec .glider-next"
            )
            .focus();
        }
      }
      var doc6 = document.querySelector(
        ".product-recomendations-section .controls-rec .glider-next"
      );
      if (doc1 == doc6) {
        if (
          document.querySelector(
            "#product_recomendation_body .rec-products:first-child .product-details-card a"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(
              "#product_recomendation_body .rec-products:first-child .product-details-card a"
            )
            .focus();
        }
      }
      var doc6 = document.querySelector(
        "#product_recomendation_body .rec-products:last-child .product-thumb"
      );
      if (doc1 == doc6) {
        if (
          document.querySelector(
            ".recently-viewed-section .controls .glider-prev"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(".recently-viewed-section .controls .glider-prev")
            .focus();
        }
      }
      var doc7 = document.querySelector(
        ".recently-viewed-section .controls .glider-prev"
      );
      if (doc1 == doc7) {
        if (
          document.querySelector(
            ".recently-viewed-section .controls .glider-next"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(".recently-viewed-section .controls .glider-next")
            .focus();
        }
      }
      var doc8 = document.querySelector(
        ".recently-viewed-section .controls .glider-prev"
      );
      if (doc1 == doc8) {
        if (
          document.querySelector(
            ".recently-viewed-section .controls .glider-next"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(".recently-viewed-section .controls .glider-next")
            .focus();
        }
      }
      var doc9 = document.querySelector(
        ".recently-viewed-section .controls .glider-next"
      );
      if (doc1 == doc9) {
        if (
          document.querySelector(
            ".recently_viewed_products2>div:first-child .product-details-card a"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(
              ".recently_viewed_products2>div:first-child .product-details-card a"
            )
            .focus();
        }
      }
      var doc10 = document.querySelector(
        ".recently_viewed_products2>div:last-child .product-thumb"
      );
      if (doc1 == doc10) {
        if (
          document.querySelector(
            ".footer-top #accordion .links-list .footer-menu:first-child a"
          )
        ) {
          event.preventDefault();
          document
            .querySelector(
              ".footer-top #accordion .links-list .footer-menu:first-child a"
            )
            .focus();
        }
      }
      var doc11 = document.querySelector("#MainContent");
      if (doc1 == doc11) {
        if (
          document.querySelector(".product-medaia-slider-controls .glider-prev")
        ) {
          event.preventDefault();
          document
            .querySelector(".product-medaia-slider-controls .glider-prev")
            .focus();
        } else if (document.querySelector(".product-images .slides div a")) {
          event.preventDefault();
          document.querySelector(".product-images .slides div a").focus();
        }
      }
      var doc12 = document.querySelector(
        ".product-medaia-slider-controls .glider-prev"
      );
      if (doc1 == doc12) {
        if (document.querySelector(".js-slides .tns-slide-active a")) {
          event.preventDefault();
          document.querySelector(".js-slides .tns-slide-active a").focus();
        }
      }
      var doc13 = document.querySelector(".js-slides .tns-slide-active a");
      if (doc1 == doc13) {
        if (
          document.querySelector(".product-medaia-slider-controls .glider-next")
        ) {
          event.preventDefault();
          document
            .querySelector(".product-medaia-slider-controls .glider-next")
            .focus();
        }
      }
      var doc14 = document.querySelector(
        ".product-medaia-slider-controls .glider-next"
      );
      if (doc1 == doc14) {
        if (
          document.querySelector("#controls-thumbnails .glider-prev") &&
          document.querySelector("#controls-thumbnails").style.display != "none"
        ) {
          event.preventDefault();
          document.querySelector("#controls-thumbnails .glider-prev").focus();
        } else if (
          document.querySelector(".product-thumbnails > a.tns-slide-active")
        ) {
          event.preventDefault();
          document
            .querySelectorAll(".product-thumbnails > a.tns-slide-active")[0]
            .focus();
        } else if (document.querySelector(".single-product-details > a")) {
          event.preventDefault();
          document.querySelector(".single-product-details > a").focus();
        } else if (document.querySelector(".product-vendor a")) {
          event.preventDefault();
          document.querySelector(".product-vendor a").focus();
        }
      }
      var doc15 = document.querySelector("#controls-thumbnails .glider-prev");
      if (doc1 == doc15) {
        if (
          document.querySelector(".product-thumbnails > a.tns-slide-active")
        ) {
          event.preventDefault();
          document
            .querySelector(".product-thumbnails > a.tns-slide-active")
            .focus();
        }
      }
      var docAll = document.querySelectorAll(
        ".product-thumbnails > a.tns-slide-active"
      );
      var doc16 = document.querySelectorAll(
        ".product-thumbnails > a.tns-slide-active"
      )[docAll.length - 1];
      if (doc1 == doc16) {
        if (
          document.querySelector("#controls-thumbnails .glider-next") &&
          document.querySelector("#controls-thumbnails").style.display != "none"
        ) {
          event.preventDefault();
          document.querySelector("#controls-thumbnails .glider-next").focus();
        } else if (document.querySelector(".single-product-details a")) {
          event.preventDefault();
          document.querySelector(".single-product-details a").focus();
        }
      }
      var doc17 = document.querySelector("#controls-thumbnails .glider-next");
      if (doc1 == doc17) {
        if (document.querySelector(".single-product-details > a")) {
          event.preventDefault();
          document.querySelector(".single-product-details > a").focus();
        }
      }
    }
    if (document.querySelectorAll("#cart").length > 0) {
      var doc2 = document.activeElement;
      document
        .querySelectorAll(
          "#page-cart-inner #cart-fieldset .cart-items>.line-item"
        )
        .forEach(function (selfClass, index) {
          var doc1 = selfClass.querySelector(".js-quantity-button.plus");
          if (doc1 == doc2) {
            if (
              document.querySelector(
                "#page-cart-inner #cart-fieldset .cart-items>.line-item:nth-child(" +
                  (index + 2) +
                  ") .line-image a"
              )
            ) {
              event.preventDefault();
              document
                .querySelector(
                  "#page-cart-inner #cart-fieldset .cart-items>.line-item:nth-child(" +
                    (index + 2) +
                    ") .line-image a"
                )
                .focus();
            }
          }
        });
    }
  }
});
// Accordion functionality js
var titles = document.querySelectorAll(".faq-item-wrapper .faq-item");
var firstItem = document.querySelector(
  ".faq-item-wrapper:first-child .faq-item"
);
var lastItem = document.querySelector(".faq-item-wrapper:last-child .faq-item");
if (document.querySelectorAll(".faq-item-wrapper .faq-item") != null) {
  titles.forEach(function (item, index) {
    item.onclick = function () {
      titles.forEach(function (faq) {
        if (item != faq) {
          var content = faq
            .closest(".faq-item-wrapper")
            .querySelector(".faq-item-content");
          content.classList.remove("show-faq-content");
          faq.closest(".faq-item-wrapper").classList.remove("border-bottom");
          faq.closest(".faq-item-wrapper").classList.remove("active-faq");
          faq.closest(".faq-item-wrapper").classList.remove("border-top");
        }
      });
      var content = item
        .closest(".faq-item-wrapper")
        .querySelector(".faq-item-content");
      if (content.classList.contains("show-faq-content")) {
        content.classList.remove("show-faq-content");
        item.closest(".faq-item-wrapper").classList.remove("border-bottom");
        item.closest(".faq-item-wrapper").classList.remove("active-faq");
        item.closest(".faq-item-wrapper").classList.remove("border-top");
      } else {
        content.classList.add("show-faq-content");
        item.closest(".faq-item-wrapper").classList.add("active-faq");
        if (firstItem != item) {
          item.closest(".faq-item-wrapper").classList.add("border-top");
        }
        if (lastItem != item) {
          item.closest(".faq-item-wrapper").classList.add("border-bottom");
        }
      }
    };
  });
}
// Accordion accesibility js
if (document.querySelectorAll(".faq-item-wrapper") != null) {
  document.addEventListener("keydown", function (event) {
    var activeElement = document.activeElement;
    if (event.key === "Enter") {
      titles.forEach(function (item, index) {
        var wrp = item.closest(".faq-item-wrapper");
        if (activeElement === wrp) {
          titles.forEach(function (faq) {
            if (item != faq) {
              var content = faq
                .closest(".faq-item-wrapper")
                .querySelector(".faq-item-content");
              content.classList.remove("show-faq-content");
              faq
                .closest(".faq-item-wrapper")
                .classList.remove("border-bottom");
              faq.closest(".faq-item-wrapper").classList.remove("active-faq");
              faq.closest(".faq-item-wrapper").classList.remove("border-top");
            }
          });
          var content = item
            .closest(".faq-item-wrapper")
            .querySelector(".faq-item-content");
          if (content.classList.contains("show-faq-content")) {
            content.classList.remove("show-faq-content");
            item.closest(".faq-item-wrapper").classList.remove("border-bottom");
            item.closest(".faq-item-wrapper").classList.remove("active-faq");
            item.closest(".faq-item-wrapper").classList.remove("border-top");
          } else {
            content.classList.add("show-faq-content");
            item.closest(".faq-item-wrapper").classList.add("active-faq");
            if (firstItem != item) {
              item.closest(".faq-item-wrapper").classList.add("border-top");
            }
            if (lastItem != item) {
              item.closest(".faq-item-wrapper").classList.add("border-bottom");
            }
          }
        }
      });
    }
  });
}
// Elysian accessibility
// active the page first element
// window.addEventListener("load", function (event) {
//   var skipContent = document.querySelector(".skip-to-content-link");
//   if (skipContent != null && Shopify.designMode != true) {
//     skipContent.setAttribute("tabindex", 0);
//     setTimeout(function () {
//       skipContent.focus();
//       skipContent.style.opacity = 0;
//       skipContent.style.visibility = "hidden";
//     }, 1000);
//   }
// });
window.addEventListener("load", function (event) {
  var skipContent = document.querySelector(".skip-to-content-link");
  if (skipContent != null && Shopify.designMode != true) {
    skipContent.setAttribute("tabindex", 0);
    setTimeout(function () {
      skipContent.style.opacity = 0;
      skipContent.style.visibility = "hidden";
      skipContent.focus();
    }, 1000);
  }
});
document.addEventListener("keydown", function (event) {
  var activeElement = document.activeElement;
  setTimeout(function () {
    // header variables
    var btnFloating = document.querySelector(".floating-menu-button-wrapper a");
    var menuFirstItem = document.querySelector(
      ".desktop-sidebar-menu-parent-items > li:first-child > a"
    );
    var searchResultLink = document.querySelector(
      ".js-search-result-page-link"
    );
    var searchModalOverlay = document.querySelector(".overlay-search");
    var searchResult = document.querySelector(".header-search__results");
    var btnCloseModal = document.querySelector(".js-search-close");
    var modalSearch = document.querySelector(".js-search-modal");
    var form = modalSearch.querySelector(".header-search");
    var buttonInput = form.querySelector('input[name="q"]');
    var searchBtn = document.querySelector("aside .js-search-modal-link");
    var searchModalInput = document.querySelector(
      ".js-search-modal .js-search-input"
    );
    var cartClose = document.querySelector(".js-close-cart");
    var cartTab = document.querySelector(".js-menu-toggle");
    // page content variables
    var firstSection = document.querySelector(
      '#MainContent section[tabindex="0"]'
    );
    var sliderPrev = document.querySelector(".js-slider-sites-prev");
    var sliderNext = document.querySelector(".js-slider-sites-next");
    var cartNote = document.querySelector(
      ".mini-cart-recommendations .tax-note"
    );
    var recCartLastButton = document.querySelector(
      ".cart-recommendations-drawer .product-card-item:last-child .button"
    );
    // Collection filter variables
    var labelsFilter = document.querySelectorAll(
      ".collection-filter-sidebar .form-check-label"
    );
    var btnsPills = document.querySelectorAll(
      ".collection-filter-button,.filter-by-nav-pills li a"
    );
    var filterClose = document.querySelector(".collection-filter-close");
    var filterApply = document.querySelector(".filter-apply-btn");
    var pillsTab = document.querySelector(".filter-by-nav-pills");
    console.log(activeElement);
    if (event.key === "Tab" && !event.shiftKey) {
      // floating menu btn on load
      var body = document.body;
      if (btnFloating != null && activeElement == body) {
        btnFloating.focus();
      } else if (menuFirstItem != null && activeElement == body) {
        menuFirstItem.focus();
      }
      // search form header
      if (btnCloseModal != null && buttonInput != null) {
        if (btnCloseModal == activeElement) {
          buttonInput.focus();
        }
      }
      if (searchResultLink != null && searchResultLink == activeElement) {
        document.body.classList.remove("show-search-modal");
        searchBtn.focus();
        searchModalOverlay.classList.remove("show-overlay");
        searchModalOverlay.classList.remove("header-search__overlay");
        searchResult.style.display = "none";
      }
      if (searchModalInput != null && searchModalInput == activeElement) {
        var form = modalSearch.querySelector(".header-search");
        if (searchModalInput.value == "") {
          if (form != null) {
            form.setAttribute("tabindex", "-1");
          }
          document.body.classList.remove("show-search-modal");
          searchBtn.focus();
        }
      }

      // access next page section after cart drawer close
      if (firstSection != null && recCartLastButton != null) {
        if (activeElement == recCartLastButton) {
          cartClose.click();
          cartTab.focus();
        }
      } else if (firstSection != null && cartNote != null) {
        if (activeElement == cartNote) {
          cartClose.click();
          cartTab.focus();
        }
      }
      // focusout filter
      if (filterApply != null) {
        if (filterApply == activeElement) {
          filterClose.click();
          btnsPills[0].focus();
          if (labelsFilter != null) {
            labelsFilter.forEach(function (lable, index) {
              lable.setAttribute("tabindex", "-1");
            });
          }
        }
      }
      // accessibility for product cards btns
      var items = document.querySelectorAll(
        ".product-card-item .js-slider-product"
      );
      if (items.length > 0) {
        items.forEach(function (item) {
          var eleFocused = item.querySelector("figure.card-product__figure a");
          if (eleFocused != null) {
            eleFocused.onfocus = function () {
              items.forEach(function (itemCurrent) {
                var eleCurrent = itemCurrent.querySelector(
                  "figure.card-product__figure a"
                );
                var btnCurrent = itemCurrent.querySelector(
                  ".quick-form-wrapper"
                );
                if (eleCurrent != null && btnCurrent != null) {
                  if (eleFocused == eleCurrent) {
                    btnCurrent.style.visibility = "visible";
                    btnCurrent.style.opacity = 1;
                  } else {
                    btnCurrent.style.visibility = "";
                    btnCurrent.style.opacity = "";
                  }
                }
              });
            };
          }
        });
      }
    }
    if (event.key === "Tab" && event.shiftKey) {
      // focusout filter
      if (filterClose != null && pillsTab != null) {
        if (filterClose == activeElement) {
          filterClose.click();
          pillsTab.focus();
          if (labelsFilter != null) {
            labelsFilter.forEach(function (lable, index) {
              lable.setAttribute("tabindex", "-1");
            });
          }
        }
      }
    }
    if (event.key === "Enter") {
      // product page sizeguide
      var tabs = document.querySelectorAll(".size-guide-tab-listing li");
      if (tabs.length > 0) {
        tabs.forEach(function (tab) {
          if (activeElement == tab) {
            var rows = tab
              .closest(".size-guide-wrp")
              .querySelectorAll(".size-guide-table-wrp table");
            if (rows.length > 0) {
              rows.forEach(function (row) {
                row.classList.add("hidden");
              });
            }
            tabs.forEach(function (tab) {
              tab.classList.remove("active-tab");
            });
            var table = tab.dataset.table;
            var row = tab.closest(".size-guide-wrp").querySelector("." + table);
            row.classList.remove("hidden");
            tab.classList.add("active-tab");
          }
        });
      }
      // focus first menu sidebar
      if (
        btnFloating != null &&
        menuFirstItem != null &&
        activeElement == btnFloating
      ) {
        setTimeout(function () {
          menuFirstItem.focus();
        }, 800);
      }

      // search form header
      if (btnCloseModal != null && searchBtn != null) {
        if (btnCloseModal == activeElement) {
          searchBtn.focus();
        }
      }

      if (activeElement == cartClose) {
        cartClose.click();
        cartTab.focus();
      }
      if (sliderPrev != null && sliderPrev == activeElement) {
        sliderPrev.click();
      }
      if (sliderNext != null && sliderNext == activeElement) {
        sliderPrev.click();
      }
      // Code for product input pills
      var radioWraps = document.querySelectorAll(".styled-pills-radio");
      if (radioWraps != null) {
        radioWraps.forEach(function (radioWrap, index) {
          var radios = radioWrap.querySelectorAll('input[type="radio"]');
          if (radios != null) {
            radios.forEach(function (radio, index) {
              var inputSelector = activeElement.getAttribute("for");
              if (activeElement.closest(".styled-pills-radio") != null) {
                var radioTofocus = activeElement
                  .closest(".styled-pills-radio")
                  .querySelector("#" + inputSelector);
                if (radioTofocus == radio) {
                  radioTofocus.checked = true;
                  radioTofocus.onchange();
                }
              }
            });
          }
        });
      }
      // code for collection filter
      if (labelsFilter != null) {
        labelsFilter.forEach(function (lable, index) {
          if (activeElement == lable) {
            lable.click();
          }
        });
      }
      // collection filter pills/tab
      if (btnsPills != null) {
        btnsPills.forEach(function (btn, index) {
          if (activeElement == btn) {
            if (filterClose != null) {
              setTimeout(function () {
                filterClose.focus();
              }, 1000);
              if (labelsFilter != null) {
                labelsFilter.forEach(function (lable, index) {
                  lable.setAttribute("tabindex", 0);
                });
              }
            }
          }
        });
      }
      // close filter
      if (filterClose != null) {
        if (activeElement == filterClose) {
          if (document.querySelector(".collection-filter-button") != null) {
            document.querySelector(".collection-filter-button").focus();
          }
          if (pillsTab != null) {
            pillsTab.focus();
            if (labelsFilter != null) {
              labelsFilter.forEach(function (lable, index) {
                lable.setAttribute("tabindex", "-1");
              });
            }
          }
        }
      }
    }
    // to scrollintoview sections which have gsap animations
    if (document.querySelectorAll(".animation-applied-element").length > 0) {
      gsap.set(".animation-applied-element", {
        clearProps: true,
      });
      if (activeElement.closest(".animation-applied-element")) {
        setTimeout(function () {
          var active = document.activeElement;
          var section = active.closest(".animation-applied-element");
          if (active.closest("body#article") == null) {
            gsap.to(window, {
              duration: 0.1,
              scrollTo: {
                y: section,
              },
            });
          }
        }, 0);
      }
    }

    //move focus to cart drawer
    var addToCartBtns = document.querySelectorAll(".add-to-cart-button");
    if (addToCartBtns.length > 0) {
      if (event.key === "Enter") {
        addToCartBtns.forEach(function (addToCartBtn) {
          if (activeElement == addToCartBtn) {
            addToCartBtn.setAttribute("data-focused", true);
            document.querySelector("aside.sidebar").focus();
          }
        });
      }
    }
    if (document.querySelectorAll("#product").length > 0) {
      var acc = document.querySelector(".product-info-accordion a");
      var foucsedEle = document.querySelector("[data-focused]");
      if (event.key === "Enter") {
        if (activeElement == cartClose) {
          if (foucsedEle != null) {
            if (acc != null) {
              acc.focus();
              foucsedEle.removeAttribute("data-focused");
            }
          }
        }
      }
      if (event.key === "Tab" && !event.shiftKey) {
        var cartSummary = document.querySelector(".mini-cart-recommendations");
        if (cartSummary != null) {
          var cartBtn = cartSummary.querySelector(".mini-container");
          var n = cartBtn.querySelector(".view-cart-btn").length;
          var span = cartSummary.querySelector(".tax-note a");
          var recCartLastButton = document.querySelector(
            ".cart-recommendations-drawer .product-card-item:last-child .button"
          );
          if (recCartLastButton != null) {
            if (recCartLastButton == activeElement) {
              document.querySelector("body").classList.remove("show-sidebar");
              if (foucsedEle != null) {
                if (acc != null) {
                  acc.focus();
                  foucsedEle.removeAttribute("data-focused");
                }
              } else {
                mainMenu.focus();
              }
            }
          } else {
            if (span == activeElement) {
              console.log("card drawer focusout");
              document.querySelector("body").classList.remove("show-sidebar");
              if (foucsedEle != null) {
                if (acc != null) {
                  acc.focus();
                  foucsedEle.removeAttribute("data-focused");
                }
              } else {
                mainMenu.focus();
              }
            }
          }
        }
      }
    }
  }, 5);
});
